import * as React from 'react';
import styles from './Footer.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {PhoneIcon, WhatAppIcon} from '../../style-guide/icons';
import MailIcon from '../../style-guide/icons/MailIcon';

export const Footer = (props) => {
  const inlineStyle = 'text-nowrap px-2 py-1 my-1';
  const titleStyle = 'p-2 mb-0';
  const wrapRowStyle = 'flex flex-wrap';

  const {
    copyright = '© TODOS LOS DERECHOS RESERVADOS',
    copyrightInfoDate = 'Asesorías DOX, 2021',
    visitWebsite1 = 'www.totalcheck.cl',
    visitWebsite2 = 'www.dox.cl',
    email = 'soporte-idauto@dox.cl',
    // phone = '+56 2 6543 8765',
    whatsapp = '+56 999846063'
  } = props;

  return (
    <footer className={styles.footer}>
      <div className="flex flex-wrap" style={{ margin: 'auto' }}>
        <div className="flex-auto">
          <label className={titleStyle}>CONTÁCTENOS</label>
          <div className={wrapRowStyle}>
            <span className={inlineStyle}>
              <span className={styles.inlineIcon}>
                <MailIcon fontSize="small"/>
              </span>
              <a href={"mailto:" + email}>{email}</a>
            </span>
            <span className={inlineStyle}>
                <span className={styles.inlineIcon}>
                  <PhoneIcon fontSize="small"/>
                </span>
                <span>{'-'}</span>
            </span>
            <span className={inlineStyle}>
                <span className={styles.inlineIcon}>
                  <WhatAppIcon fontSize="small"/>
                </span>
                <span>{whatsapp}</span>
            </span>
          </div>
        </div>

        <div className="flex-auto hidden md:flex">
          <div className="flex-auto">
            <label className={titleStyle}>VISÍTENOS</label>
            <div className={wrapRowStyle}>
              <a className={inlineStyle} rel="noreferrer noopener" href={`http://${visitWebsite1}`} alt="sitio de interés" target="_blank"> {visitWebsite1}</a>
              <a className={inlineStyle} rel="noreferrer noopener" href={`http://${visitWebsite2}`} alt="sitio oficial de la empresa" target="_blank"> {visitWebsite2}</a>
            </div>
          </div>
          <div className={clsx('flex-auto', styles.copyright)}>
            <div className="flex flex-col h-full">
              <p style={{marginTop: 'auto'}}> {copyright}</p>
              <p style={{marginBottom: 'auto'}}>{copyrightInfoDate}</p>
            </div>
          </div>
        </div>


        <div className="flex flex-auto md:hidden">
          <div className="flex-auto">
            <label className={titleStyle}>VISÍTENOS</label>
            <div className="flex items-center justify-between">
              <a className="ml-2" rel="noreferrer noopener" href={`http://${visitWebsite1}`}
                 alt="sitio de interés" target="_blank"> {visitWebsite1}</a>
              <a className={inlineStyle} rel="noreferrer noopener" href={`http://${visitWebsite2}`}
                 alt="sitio oficial de la empresa" target="_blank"> {visitWebsite2}</a>
              <p className={inlineStyle}> {copyrightInfoDate}</p>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

Footer.propTypes = {
  copyright: PropTypes.string,
  copyrightInfoDate: PropTypes.string,
  visitWebsite1: PropTypes.string,
  visitWebsite2: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  whatsapp: PropTypes.string,

};


export default React.memo(Footer);
